import React from 'react';
import cn from 'classnames';
import { Icon } from '@landing/ui';

import * as styles from './SliderButton.module.scss';

export function SliderButton({ className, handleClick, disabled }) {
  return (
    <button
      className={cn(className, styles.wrapper)}
      onClick={handleClick}
      aria-label="Slider button"
      disabled={disabled}
    >
      <Icon className={styles.arrow} name="slider-arrow" />
    </button>
  );
}
